import { Flex, GridItem, Text } from "@chakra-ui/react";
import * as React from "react";

function DataGridItem({
                        colSpan,
                        rowSpan,
                        children,
                        fontSize = "sm",
                        fontWeight = "normal",
                        alignItems = "center",
                        justifyContent = "start",
                        isText = true
                      }) {
  return (
    <GridItem colSpan={colSpan ?? 1} rowSpan={rowSpan ?? 1}>
      <Flex padding="10px 5px" border="1px solid lightgray" height="100%" alignItems={alignItems}
            justifyContent={justifyContent}>
        {isText ? <Text
          display="flex"
          fontSize={fontSize}
          fontWeight={fontWeight}
        >
          {children}
        </Text> : children}
      </Flex>
    </GridItem>
  );
}

export default DataGridItem;